<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Add SMS Template</h5>
      <form [formGroup]="AddNewSMSText" (submit)="SubmitAddNewSMSText()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">SMS Template Title</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">Enter the SMS template title.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">SMS Message</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Enter the SMS message.</small>
          </div>
        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewSMSText.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
          <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
          <button routerLink="/SMSText" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

